import { render, staticRenderFns } from "./Instagramfeed.vue?vue&type=template&id=5393e7a2&"
import script from "./Instagramfeed.vue?vue&type=script&lang=js&"
export * from "./Instagramfeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports